// import Vue from 'vue'
import { createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './firebase'
import './assets/scss/app.scss'

//import helpers from '@/helpers'

//Vue.config.productionTip = false


let app
auth.onAuthStateChanged(user => {
  if (!app) {
    //.use(helpers)
    app = createApp(App).use(store).use(router).mount('#app')
    if (user) {
      store.dispatch('loginStore/fetchUserProfile', user)
    }
  }
})
